
/**
 * @deprecated
 * @inheritDoc
 * @see /client/containers/RedeemZsc/constants.js
 * @desc similar constant defined at {/client/containers/RedeemZsc/constants.js}
 */
import { DEFAULT_PRODUCT_TYPES } from '../GiftCardsList/constants';

const TEXT_NO_GIFTCARD = 'No Gift Cards To Display';
const DEFAULT_REDEEMGIFTCARD_PAYLOAD = {
  category_ids: '',
  client_ids: '',
  include: 'variations,variation_types',
  page: 1,
  payment_method: 'zaggle_card',
  per_page: 12,
  product_types: DEFAULT_PRODUCT_TYPES,
  vendor_ids: '',
};

const TYPE_FILTERS = [
  {
    filterName: 'evoucher',
    id: 'evoucher',
    name: 'e Gift Vouchers',
  },
  {
    filterName: 'physical_voucher',
    id: 'physical_voucher',
    name: 'Physical Gift Vouchers',
  },
];

/**
 *
 * @deprecated
 */
// const CONSTRUCT_MOBILE_FILTER_PAYLOAD = (category, discount, brand, type) => {
//   const payload = [
//     {
//       filterTitle: 'Category',
//       payloadKey: 'category',
//       isActive: true,
//       index: 0,
//     },
//     {
//       filterTitle: 'Type',
//       payloadKey: 'type',
//       isActive: false,
//       index: 1,
//     },
//     {
//       filterTitle: 'Discounts',
//       payloadKey: 'discount',
//       isActive: false,
//       index: 2,
//     },
//     // {
//     //   filterTitle: 'Brand',
//     //   payloadKey: 'brand',
//     //   isActive: false,
//     //   index: 3,
//     // },
//   ];
//   return payload;
// };

const MAKE_FILTER_ACTIVE = (data, key, filterTitle) => {
  data.forEach((element) => {
    const _element = element;
    _element.isActive = _element.payloadKey === key && _element.filterTitle === filterTitle && true;
  });
  return data;
};


const CONSTRUCT_MOBILE_FILTER_KEYS = [
  {
    filterTitle: 'Category',
    payloadKey: 'category',
    isActive: true,
    index: 0,
  },
  {
    filterTitle: 'Type',
    payloadKey: 'type',
    isActive: false,
    index: 1,
  },
  {
    filterTitle: 'Discounts',
    payloadKey: 'discount',
    isActive: false,
    index: 2,
  },
  // {
  //   filterTitle: 'Brand',
  //   payloadKey: 'brand',
  //   isActive: false,
  //   index: 3,
  // },
];

const SWITCH_PAYLOADS = ({ CategoryListArray, TypeListArray, DiscountListArray, BrandListArray, dealFilter, collectionFilter }, payloadKey, filterTitle, callback) => {
  switch (payloadKey) {
    case 'category':
      callback(payloadKey, CategoryListArray);
      break;
    case 'type':
      callback(payloadKey, TypeListArray);
      break;
    // case 'tag_types':
    //   if (filterTitle === 'Deal Type') {
    //     callback(payloadKey, dealFilter, 'Deal Type');
    //   } else if (filterTitle === 'Collections') {
    //     callback(payloadKey, collectionFilter, 'Collections');
    //   }
    //   break;
    case 'discount':
      callback(payloadKey, DiscountListArray);
      break;
    case 'brand':
      callback(payloadKey, BrandListArray);
      break;

    default:
      break;
  }
};

const CONSTRUCT_DIS_KEYS = (payload, key_One, key_Second) => {
  const values = payload.map((item) => {
    const _item = item;
    if (_item[key_Second] === 4) {
      _item.filterName = 'Less than 5%';
    } else {
      _item.filterName = `${_item[key_One]}% and above`;
    }
    return _item;
  });
  return values;
};

const CONSTRUCT_FILTER_ACTION_PAYLOAD = (checkList, payload, DiscountListArray, name = '') => {
  const checkListData = { ...checkList };
  const category_ids = checkListData.category.join();
  const vendor_ids = checkListData.brand.join();
  const product_types = checkListData.type.length ? checkListData.type.join() : payload.product_types;
  let discountObj = {};
  for (let i = 0; i < checkList.discount.length; i += 1) {
    const key = checkList.discount[i];
    for (let j = 0; j < DiscountListArray.length; j += 1) {
      if (key === DiscountListArray[j].filterName) {
        if (discountObj && 'min' in discountObj) {
          if (DiscountListArray[j].min < discountObj.min) {
            discountObj.min = DiscountListArray[j].min;
          }
          if (discountObj.max < DiscountListArray[j].max) {
            discountObj.max = DiscountListArray[j].max;
          }
        } else {
          discountObj = {
            min: DiscountListArray[j].min,
            max: DiscountListArray[j].max,
          };
        }
      }
    }
  }
  if (discountObj && 'min' in discountObj) {
    return { ...payload, category_ids, vendor_ids, min_discount: discountObj.min, max_discount: discountObj.max, product_types, name };
  }
  return { ...payload, category_ids, vendor_ids, product_types, name };
};

const MAP_GIFTCARD_KEYS = (payload) => {
  const data = payload && payload.map((item, i) => ({
    image: item && item.image && item.image.image && item.image.image.url,
    title: item.name,
    discountText: item && item.discounts_percent && item.discounts_percent.payment_gateway,
    type: 'giftLanding-type',
    amounts: getArray(item.variations, item.id, 'AMOUNTS'),
    // amounts: item.variation_types && item.variation_types[0].values,
    slug: item.slug,
    product_type: item.product_type,
    key: i,
    is_free_field: getArray(item.variations, item.id, 'CHECK_FREE_FIELD'),
    currency_symbol: item.currency_symbol,
  }));
  return data;
};

function getArray(dataArray, product_id, key) {
  switch (key) {
    case 'AMOUNTS': {
      const data = [];
      for (let i = 0; i < (dataArray && dataArray.length); i += 1) {
        if (!dataArray[i].free_field) {
          const { id: product_variation_id, name, price_cents } = dataArray[i];
          data.push({ product_variation_id, name, product_id, price_cents });
        }
      }
      return data;
    }
    case 'CHECK_FREE_FIELD': {
      const is_free_field = dataArray && dataArray[0].free_field;
      return is_free_field;
    }
    default:
      return [];
  }
}

const TEXT_NO_MERCHANT = 'No Merchandise To Display';

const GIFT_TEXT_HEADER = {
  MERCHANT_GIFT_TEXT: 'Buy Merchandise',
  GIFT_TEXT: 'Buy Gift Cards',
};

const LYRA_DUMMY_FILTER = [{
  id: 'gift-card',
  name: 'Gift Card',
  status: true,
  sub_categories: [],
  filterName: 'Gift Card',
}];

export {
  TEXT_NO_GIFTCARD, DEFAULT_REDEEMGIFTCARD_PAYLOAD, TYPE_FILTERS, // CONSTRUCT_MOBILE_FILTER_PAYLOAD,
  MAKE_FILTER_ACTIVE, CONSTRUCT_MOBILE_FILTER_KEYS, SWITCH_PAYLOADS, CONSTRUCT_DIS_KEYS, CONSTRUCT_FILTER_ACTION_PAYLOAD,
  MAP_GIFTCARD_KEYS, TEXT_NO_MERCHANT, GIFT_TEXT_HEADER, LYRA_DUMMY_FILTER,
};



// WEBPACK FOOTER //
// client/containers/GiftCard/constants.js